import fetchRequest from '../util/fetch'
import errUtil from '../util/error'

const query = `mutation CycleCreateMutation (
  $workspace: ID!,
  $data: CycleData!
) {
  cycleCreate (
    workspace: $workspace
    data: $data
  ) {
    id
  }
}`

async function requestCycleCreate (variables, token) {
  const response = await fetchRequest({
    variables,
    query,
    token
  })
  if (!response) return errUtil.noResponse()

  const { errors, data } = response
  if (errors) {
    return errUtil.apiError('cycle-create', errors)
  }
  return data.cycleCreate
}

export default requestCycleCreate
